import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Auth } from 'aws-amplify';
import { Redirect, withRouter } from 'react-router-dom';

import SignInForm from '../components/SignInForm';
import ChangePasswordForm from '../components/ChangePasswordForm';
import Loader from '../components/Loader';
import HeaderLoggedOut from '../components/HeaderLoggedOut';
import createFromAdminCreated from '../services/user/createFromAdminCreated';
import migrateTeam from '../services/team/migrateTeam';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 450,
    marginTop: theme.spacing.unit * 8,
  }),
  wrapper: {
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: '#f1f7e9',
    height: 2400,
  },
});

class SignIn extends Component {
  state = {
    isLoading: false,
    email: '',
    name: '',
    password: '',
    confirmPassword: '',
    newUser: null,
    showChangePassword: false,
    user: null,
  };

  componentWillUnmount() {
    this.setState({
      isLoading: false,
    });
  }

  validateForm = () => {
    if (this.state.showChangePassword === false) {
      return this.state.email.length > 2 && this.state.password.length >= 8;
    } else {
      return (
        this.state.name.length >= 1 &&
        validatePassword(this.state.password, this.state.confirmPassword)
      );
    }
  };

  handleChange = event => {
    let email = '';
    if (event.target.id === 'email') {
      email = event.target.value.toLowerCase();
      this.setState({
        email,
      });
    } else {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  };

  handleSubmitChangePassword = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      await Auth.completeNewPassword(this.state.user, this.state.password, {
        name: this.state.name,
      });
    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }

    Auth.currentUserCredentials().then(async res => {
      const userName = this.state.user.username;

      let newUser = null;
      newUser = await createFromAdminCreated(userName);

      const team_data = {
        plan: newUser.planId,
        customerId: newUser.s_customerId,
        listingsAllowed: newUser.listingsAllowed,
        localPhoneNumber: newUser.localPhoneNumber,
      };
      const newTeam = await migrateTeam(team_data);

      this.props.history.push('/home/new-signrider', {
        ...newUser,
        ...newTeam,
      });
    });
  };

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });
    try {
      const user = await Auth.signIn(this.state.email, this.state.password);

      if (
        user.challengeName &&
        user.challengeName === 'NEW_PASSWORD_REQUIRED'
      ) {
        this.setState({
          password: '',
          showChangePassword: true,
          isLoading: false,
          user,
        });
      } else {
        this.props.userHasAuthenticated(true);
      }
    } catch (e) {
      this.setState({ isLoading: false });
    }
  };

  handleClick = event => {
    event.preventDefault();
    this.props.history.push('/forgot-password');
  };

  render() {
    const { classes } = this.props;
    const { isLoading, showChangePassword } = this.state;
    const props = {
      handleChange: this.handleChange,
      handleSubmit: this.handleSubmit,
      validateForm: this.validateForm,
      handleClick: this.handleClick,
    };

    return !this.props.isAuthenticated ? (
      <div className={classes.wrapper}>
        <HeaderLoggedOut signup={true} />
        <Grid
          container
          spacing={24}
          justify="center"
          direction="column"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Paper className={classes.root} elevation={4}>
              {isLoading ? (
                <Loader loaderText="Signing In..." />
              ) : showChangePassword ? (
                <ChangePasswordForm
                  handleSubmit={this.handleSubmitChangePassword}
                  validateForm={this.validateForm}
                  handleChange={this.handleChange}
                />
              ) : (
                <SignInForm {...props} />
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
    ) : (
      <Redirect from="/signin" to="/home" />
    );
  }
}

function validatePassword(pw, confirmPw) {
  const basic = pw === confirmPw;
  const strong = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
  );

  return basic && strong.test(pw);
}

export default withRouter(withStyles(styles)(SignIn));



// WEBPACK FOOTER //
// ./src/containers/SignIn.js